<template>
  <van-popup v-model="showPicker" round :position="position">
    <van-search
      v-model="jxcdmc"
      show-action
      placeholder="支持教学场地编号名称建筑物功能区关键词搜索"
      @search="onSearch"
    >
      <template #action>
        <div @click="onClickButton">查询</div>
      </template>
    </van-search>
    <van-picker
      :title="title"
      show-toolbar
      :columns="columnsvalue"
      @confirm="onConfirm"
      @cancel="onCancel"
      :loading="loading"
      :default-index="index"
    />
  </van-popup>
</template>

<script>
    export default {
        name: "mobile-jxcd",
      props: {
        //标题
        title: {
          type: String,
          default: ''
        },
        //弹出方向
        position: {
          type: String,
          default: 'bottom'
        },
        //类型
        type: {
          type: String,
          default: ''
        },
        callbak: {
          type: Function,
          default: null,
        },
        xqjc: {
          type: String,
          default: ''
        },
        kkzc: {
          type: Number,
          default: ''
        },
        pkrs: {
          type: Number,
          default: ''
        },
        kkxqdm: {
          type: String,
          default: ''
        },
      },
      data() {
        return {
          showPicker:false,
          value:null,
          text:null,
          columns:[],
          columnsvalue:[],
          index:0,
          dm:null,
          loading:true,
          jxcdmc:"",
          isjxcdsj:"1"

        }
      },
      created() {
      },
      methods: {
        show(show,dm,method){
          this.showPicker = show;
          this.dm = dm;
          this.getlist();
        },
        getlist(){
          let that = this;
          let datas = {
            xqjc:that.xqjc,
            isjxcdsj:that.isjxcdsj,
            kkzc:that.kkzc,
            pkrs:that.pkrs,
            jxcdmc:that.jxcdmc,
            kkxqdm:that.kkxqdm
          };
          this.$ajax.post('/appapi/teachertksq/getKycd',datas).then(function (rep) {
            if (rep.code == 200) {
              that.columns = rep.Kycdlist;
              that.columnsvalue = rep.Kycdlist;
              for(var i = 0;i < that.columns.length;i++){
                if(that.dm === that.columns[i].value){
                  that.index = i;
                }
              }
              that.loading = false;
            }
          });
        },
        onConfirm(columns, index) {
          this.value = columns.value;
          this.text = columns.text;
          this.index = index;
           this.callbak(this.value,this.text);
          this.showPicker = false;
        },
        onCancel() {
          this.showPicker = false;
        },
        onSearch(val)
        {
  /*        let goods = this.columns;
          this.columnsvalue=[];
          goods.map(item=>{
            if(item.text.includes(this.jxcdmc)){
              this.columnsvalue.push(item)
            }
          })*/
          this.loading = true;
          this.getlist()
        },
        onClickButton()
        {
          this.loading = true;
          this.getlist()
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/mobile-jxcd/index.vue